var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 11,
    viewBox: "0 0 16 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99984 8.50008C8.78873 8.50008 9.45817 8.22508 10.0082 7.67508C10.5582 7.12508 10.8332 6.45564 10.8332 5.66675C10.8332 4.87786 10.5582 4.20842 10.0082 3.65841C9.45817 3.10841 8.78873 2.83341 7.99984 2.83341C7.21095 2.83341 6.54151 3.10841 5.99151 3.65841C5.4415 4.20842 5.1665 4.87786 5.1665 5.66675C5.1665 6.45564 5.4415 7.12508 5.99151 7.67508C6.54151 8.22508 7.21095 8.50008 7.99984 8.50008ZM7.99984 7.53341C7.47762 7.53341 7.03595 7.35286 6.67484 6.99175C6.31373 6.63064 6.13317 6.18897 6.13317 5.66675C6.13317 5.14453 6.31373 4.70286 6.67484 4.34175C7.03595 3.98064 7.47762 3.80008 7.99984 3.80008C8.52206 3.80008 8.96373 3.98064 9.32484 4.34175C9.68595 4.70286 9.86651 5.14453 9.86651 5.66675C9.86651 6.18897 9.68595 6.63064 9.32484 6.99175C8.96373 7.35286 8.52206 7.53341 7.99984 7.53341ZM7.99984 10.6667C6.37762 10.6667 4.91095 10.2056 3.59984 9.28341C2.28873 8.36119 1.31095 7.15564 0.666504 5.66675C1.31095 4.17786 2.28873 2.9723 3.59984 2.05008C4.91095 1.12786 6.37762 0.666748 7.99984 0.666748C9.62206 0.666748 11.0887 1.12786 12.3998 2.05008C13.711 2.9723 14.6887 4.17786 15.3332 5.66675C14.6887 7.15564 13.711 8.36119 12.3998 9.28341C11.0887 10.2056 9.62206 10.6667 7.99984 10.6667Z",
    fill: "#616161"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/Eye.3ccae4468860f60abcb37917b10686b6.svg";
export { ForwardRef as ReactComponent };